import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardTile from './DashboardTile';
import type { UserRanking } from '@/types/dashboard';

interface RankingTileProps {
  ranking: UserRanking;
}

const RankingTile: FC<RankingTileProps> = ({ ranking }) => {
  const navigate = useNavigate();

  const trendBadge = () => {
    if (ranking.rank_change > 0) {
      return (
        <span className="inline-flex items-center gap-0.5 text-2xs font-bold px-2 py-0.5 rounded-full bg-emerald-500/15 text-emerald-400">
          ▲ {ranking.rank_change}
        </span>
      );
    }
    if (ranking.rank_change < 0) {
      return (
        <span className="inline-flex items-center gap-0.5 text-2xs font-bold px-2 py-0.5 rounded-full bg-rose-500/15 text-rose-400">
          ▼ {Math.abs(ranking.rank_change)}
        </span>
      );
    }
    return (
      <span className="inline-flex items-center text-2xs font-bold px-2 py-0.5 rounded-full" style={{ background: 'var(--tile-bar-bg)', color: 'var(--tile-text-muted)' }}>
        —
      </span>
    );
  };

  return (
    <DashboardTile onClick={() => navigate('/ranking')} data-testid="ranking-tile" data-tour="ranking-tile">
      <p
        className="text-2xs font-bold uppercase tracking-[0.15em] mb-3"
        style={{ color: 'var(--tile-text-muted)' }}
      >
        Ranking Geral
      </p>

      <div className="flex items-baseline gap-2">
        <span className="text-[26px] font-black leading-none" style={{ color: 'var(--tile-text-primary)' }}>
          {ranking.current_rank}
        </span>
        <span className="text-sm font-medium" style={{ color: 'var(--tile-text-secondary)' }}>
          º lugar
        </span>
        {trendBadge()}
      </div>

      <p className="text-xs mt-3" style={{ color: 'var(--tile-text-muted)' }}>
        {ranking.season_xp.toLocaleString('pt-BR')} XP na temporada
      </p>
    </DashboardTile>
  );
};

export default RankingTile;
